import PropTypes from 'prop-types';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './ColorSwatchIcon.scss';

const ColorSwatchIcon = ({ active = false, color, showCheckIcon = false, size = 'lg', title }) => {
  let rootCssClass = styles['color-swatch-icon'];
  rootCssClass += isMobileOnly ? ` ${styles['mobile']}` : ` ${styles['desktop']}`;
  rootCssClass += ` ${styles[size]}`;
  if (active) rootCssClass += ` ${styles['active']}`;

  return (
    <div className={rootCssClass} title={title}>
      <div className={styles['color-swatch']} style={{ backgroundColor: color }}>
        {active && showCheckIcon && (
          <img alt="" aria-hidden="true" src="/resources/assets/ui/nextgen/color_swatch_check.svg" />
        )}
      </div>
    </div>
  );
};

ColorSwatchIcon.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string.isRequired,
  showCheckIcon: PropTypes.bool,
  size: PropTypes.oneOf(['lg', 'sm']),
  title: PropTypes.string,
};

export default ColorSwatchIcon;
